import React from "react";

const summary = <p>A short comedy about a tennis player who struggles with a compartment inside his head during a big match. 1990</p>;

export default summary;